import axios, {AxiosResponse} from 'axios'

import {UTMData} from '@lib/gtm/utmContext'

import {reqBody} from './type'

export const submitForm = ({
  reqBody,
  utm,
}: {
  reqBody: reqBody
  utm: UTMData
}): Promise<AxiosResponse> => {
  return axios.post('/api/submit-form', {
    email: reqBody?.email,
    full_name: reqBody?.name,
    phone_number: reqBody?.phone,
    description: reqBody?.message,
    template: reqBody?.template,
    company_name: reqBody?.company,
    subscribe_promotion: reqBody?.allow,
    position: reqBody?.position,
    url: reqBody?.url,
    marketing_consent: reqBody?.marketing_consent,
    ...(utm && {
      lead_source: {
        utm_id: utm.id,
        utm_term: utm.term,
        utm_source: utm.source,
        utm_medium: utm.medium,
        utm_campaign: utm.campaign,
        utm_content: utm.content,
      },
    }),
  })
}
